
import { defineComponent } from 'vue'
import router from '@/router'
import { store } from './shared/store.js'

export default defineComponent({
  name: 'NavBar',
  data () {
      return {
          store,
          drawer: false,
          links: [
              { icon: 'mdi-home', title: 'Home', route: '/'},
            //   { icon: 'mdi-heart-pulse', title: 'Encounters', route: '/encounters'},
              { icon: 'mdi-account', title: 'Patient Registration', route: '/registration'},
              { icon: 'mdi-calendar-month', title: 'Appointments', route: '/appointments'},
              { icon: 'mdi-clipboard-pulse-outline', title: 'Medical Records', route: '/records'},
            //   { icon: 'mdi-view-dashboard', title: 'Dashboard', route: '/dashboard'},
            //   { icon: 'mdi-account-multiple', title: 'Team', route: '/team'},
            //   { icon: 'mdi-home', title: 'Home', route: '/'},
              { icon: 'mdi-cog-outline', title: 'Management', route: '/management'},
              { icon: 'mdi-information', title: 'About', route: '/about'}
          ]
      }
  },
  methods: {
    getImage() {
        return require('@/assets/' + this.store.avatar)
    }
  },
  mounted () {
    if (!this.store.username)
    {
        router.push({ path: '/login' })
    }
  }
})  
